import * as React from "react";
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgCartIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    data-slot="icon"
    width={24}
    height={24}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 3h1.1821c.2227 0 .334 0 .4236.0407a.45.45 0 0 1 .1928.1662c.0532.0825.0689.192.1004.4113L5.3273 6.6m0 0 .952 6.9583c.1208.883.1812 1.3245.3935 1.6568.187.2929.4552.5257.7722.6705.3598.1644.8078.1644 1.704.1644h7.7452c.8531 0 1.2796 0 1.6282-.1526a1.81 1.81 0 0 0 .7614-.6266c.216-.3119.2958-.7286.4554-1.5619l1.198-6.2542c.0561-.2933.0842-.44.0435-.5545a.45.45 0 0 0-.1988-.239c-.1056-.0612-.2558-.0612-.556-.0612zm4.913 13.5c0 .4971-.4051.9-.905.9s-.905-.4029-.905-.9.4052-.9.905-.9.905.4029.905.9m7.2404 0c0 .4971-.4052.9-.905.9s-.9051-.4029-.9051-.9.4052-.9.9051-.9.905.4029.905.9"
    />
  </svg>
);
export default SvgCartIcon;
